import React from "react";
import { DoctorIcon } from "../../../Icons";
import { physicianDirectoryApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage, {
  cellMuted,
} from "../components/LibraryCatalogPage";
import PhysicianFormModal from "./PhysicianFormModal";

const columns = [
  {
    header: "First Name",
    accessor: "firstName",
    sortable: true,
    strong: true,
  },
  {
    header: "Last Name",
    accessor: "lastName",
    sortable: true,
    strong: true,
  },
  {
    header: "Address",
    accessor: "address",
    className: "px-3 max-w-[12rem]",
    render: (row) => (
      <span className="text-[13px] text-slate-700 block truncate" title={row.address || ""}>
        {row.address || "—"}
      </span>
    ),
  },
  {
    header: "NPI",
    accessor: "npiNumber",
    sortable: true,
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>{row.npiNumber || "—"}</span>
    ),
  },
  {
    header: "Phone",
    accessor: "phone",
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>{row.phone || "—"}</span>
    ),
  },
  {
    header: "Fax",
    accessor: "fax",
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>{row.fax || "—"}</span>
    ),
  },
  {
    header: "PECOS",
    accessor: "pecosStatus",
    render: (row) => (
      <span className="text-[13px] text-slate-700 capitalize">
        {row.pecosStatus || "—"}
      </span>
    ),
  },
];

const PhysicianDirectoryPage = () => (
  <LibraryCatalogPage
    title="Physician Directory"
    icon={DoctorIcon}
    addLabel="Create New"
    searchPlaceholder="Search by name, NPI, phone..."
    entityLabel="Physician"
    defaultSortBy="lastName"
    api={physicianDirectoryApi}
    columns={columns}
    FormModal={PhysicianFormModal}
    getDeleteLabel={(row) =>
      `${row.lastName || ""}, ${row.firstName || ""}`.replace(/^,\s*|,\s*$/g, "")
    }
  />
);

export default PhysicianDirectoryPage;
